export default {
  // Navigation
  nav: {
    home: "Home",
    contact: "Contact",
    admin: "Administration",
    form: "Form",
  },

  // Header
  header: {
    eventPeriod: "From July 5<sup>th</sup> to August 31<sup>st</sup>, 2025",
  },

  // Homepage
  home: {
    title: "Welcome to Toulouse Airport",
    subtitle: "Your gateway to the world",
    description: "Discover our services and travel information",
    participate: "ENTER NOW",
    participateTitle: "SIGN UP",
    itsVerySimple: "AND WIN",
    fillCoordinates: "Enter your details",
    discoverGift: "Discover your gift",
    retrieveGift: "Collect your gift or enjoy your offer in one of the airport shops",
    gameWinning: "100% WINNING!",
    toWin: "TO WIN",
    travel: "a trip",
    wirelessHeadphones: "wireless headphones",
    vouchersAndGifts: "shopping vouchers and many other prizes",
    participationSimple: "TO TAKE PART, IT'S VERY SIMPLE,",
    gifts: "GIFTS",
  },

  // Form
  form: {
    loading: "Loading...",
    title: "Booking form",
    submit: "Submit",
    cancel: "Cancel",
    required: "This field is required",
    email: "Email address",
    name: "Full name",
    phone: "Phone",
    message: "Message",
    fillForm: "ENTER YOUR EMAIL TO",
    discoverGain: "DISCOVER YOUR GIFT",
    pleaseWait: "Please wait",
    requiredFields: "*Required field",
    privacyNotice:
      "The personal data provided by participants is processed electronically for the purposes of managing the game and is intended for Toulouse-Blagnac Airport. In accordance with the French 'Informatique et Libertés' law of January 6, 1978, as amended in 2004, and with the General Data Protection Regulation (GDPR), you have the right to access, rectify, delete, and transfer your data, as well as the right to object to or limit the processing of your data.",
    invalidEmail:
      "Your email is temporary, contains a '+', or is invalid.",
  },

  // Contact
  contact: {
    title: "Contact us",
    address: "Address",
    phone: "Phone",
    email: "Email",
    sendMessage: "Send message",
    pageTitle: "CONTACT US",
    lastName: "Your last name*",
    firstName: "Your first name*",
    emailAddress: "Your email address*",
    requestType: "Request type*",
    subject: "Subject*",
    message: "Message*",
    chooseOption: "Choose an option",
    technicalIssue: "Technical issue during my participation",
    siteNotWorking: "The game website is not working",
    gameInfo: "Request for information about the game",
    other: "Other",
    requiredFields: "*Required fields",
    send: "SEND",
    loading: "Loading...",
    fieldRequired: "This field is required",
  },

  // Administration
  admin: {
    title: "Administration",
    dashboard: "Dashboard",
    users: "Users",
    settings: "Settings",
    fillForm: "FILL IN THE FORM",
    discoverGain: "TO DISCOVER YOUR GIFT",
    pleaseWait: "Please wait",
    ticketAddedSuccess: "RECEIPT SUCCESSFULLY ADDED!",
    clickToAddAnother:
      "Click the button below to add another receipt",
    requiredFields: "*Required field",
    privacyNotice:
      "The personal data submitted by participants is processed electronically for the purpose of managing the game and is intended for Toulouse-Blagnac Airport. In accordance with the Data Protection Act of 6 January 1978, as amended in 2004, and the General Data Protection Regulation (GDPR), you have the right to access, rectify, delete and transfer the data collected, as well as the right to object to or restrict its processing.",
    uniqueCode: "Unique code",
    invalidCode: "Invalid or already used code",
    verify: "VERIFY",
    errorOccurred: "An error occurred, please try again.",
    pleaseEnterCode: "Please enter a code",
    invalidEmailMessage: "Your email is temporary, contains a '+', or is invalid.",
  },

  // General messages
  common: {
    loading: "Loading...",
    error: "An error occurred",
    success: "Operation successful",
    confirm: "Confirm",
    delete: "Delete",
    edit: "Edit",
    save: "Save",
    close: "Close",
    back: "back",
  },

  // Game Over
  gameover: {
    title: "Game Over",
    subtitle: "Thank you for participating!",
    thanksMessage: "We hope you enjoyed this experience.",
    comeBackMessage: "Come back soon for new opportunities to win prizes!",
    backToHome: "Back to Home",
    contactUs: "Contact Us",
    eventPeriod: "Event from July 5 to August 31, 2025",
  },

  // Footer
  footer: {
    rules: "Rules",
    legalNotice: "Legal notice",
    privacyPolicy: "Privacy policy",
    cookies: "Cookies",
    contactUs: "Contact us",
    slogan: "Shopping & Service: Feel it, Share it, Live Toulouse!",
  },

  // Prizes and rewards
  lots: {
    congratulations: "CONGRATS!",
    youWin: "YOU'VE WON",
    voucher5: "A €5 VOUCHER<br>(TAX INCLUDED)",
    voucher15: "A €15 VOUCHER <br> (TAX INCLUDED)",
    voucherCondition: "valid on a minimum purchase of €20 (incl. tax) except tabac and alcool in Relay stores or terminal restaurants",
    voucher15Condition: "valid on a minimum purchase of €50 (incl. tax) except tabac and alcool in any terminal shop",
    howToBenefit: "HOW TO CLAIM YOUR PRIZE?",
    findConfirmation: "<b class=\"not-italic\">FIND</b> your prize confirmation in the email sent to the address provided during your registration",
    findConfirmationVoyage: "<b class=\"not-italic\">CHECK</b> your inbox, a message will be sent to the email address provided during your registration. Don't forget to check your spam folder!",
    goToShop: "<b class=\"not-italic\">GO TO</b> one of the Relay stores or one of the terminal's restaurants and do your shopping",
    goToShop2: "<b class=\"not-italic\">RENDEZ-VOUS</b> dans l’un(e) des boutiques et restaurants de l’aérogare",
    goToShopAirpods: "<b class=\"not-italic\">GO TO</b> your Relay / Stade Toulousain / Fnac shop in the terminal where a staff member will give you your prize upon presentation of your confirmation email",
    goToShopPanier: "<b class=\"not-italic\">GO TO</b> your Relay / Stade Toulousain / Fnac shop in the terminal where a staff member will give you your prize upon presentation of your confirmation email",
    goToShopGeneral: "<b class=\"not-italic\">GO TO</b> one of the terminal shop",
    goToShopBr15: "<b class=\"not-italic\">GO TO</b> one of the terminal shop and do your shopping",
    sendCoordinates: "<b class=\"not-italic\">SEND US BACK</b> your contact details (first name, last name, and phone number), and we'll get back to you.",
    enjoyGift: "<b class=\"not-italic\">ENJOY</b> your gift",
    enjoyGift2: "<b class=\"not-italic\">ENJOY</b> your gift",
    enjoyGiftExclamation: "<b class=\"not-italic\">ENJOY</b> your gift!",
    enjoyGiftExclamation2: "<b class=\"not-italic\">ENJOY</b> your gift!",
    enjoyVoucher: "<b class=\"not-italic\">ENJOY</b> your voucher by showing your confirmation email at the checkout",
    enjoyTrip: "<b class=\"not-italic\">ENJOY</b> your stay!",
    enjoyVoucherBr15: "<b class=\"not-italic\">ENJOY</b> your voucher by showing your confirmation email at the checkout",
    warning: "Important: your prize is valid today until 11:59 PM. After this time, it will be considered lost and will be put back in the prize pool.",
    
    // Prize names
    planeTickets: "PLANE TICKETS*",
    fan: "A FAN!",
    wirelessHeadphones: "JBL WIRELESS <br>TUNE FLEX EARBUDS",
    giftBasket: "A GIFT BASKET",
    beachBall: "A BEACH BALL!",
    
    // Special conditions text
    seeRules: "*See official rules for details",
    giftBasketOrigin: "from the shops at Toulouse-Blagnac<br>airport",
  },

  // Game over page
  perd: {
    sorry: "SORRY",
    gameOver: "THE GAME IS OVER",
    thanksForParticipating: "Thank you for participating!",
  },
};